export function SurreyCTA() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: 'Phone Consultation',
      detail: '+1 (778) 386-9229',
      description: 'Speak with a Surrey STR specialist'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Inquiry',
      detail: 'contact@furnishedrentalmanagement.com',
      description: 'Get detailed information via email'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Book Meeting',
      detail: 'Schedule consultation',
      description: 'In-person or virtual property assessment'
    }
  ];

  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Ready to Start Your Surrey STR?
          </h2>
          <p className="text-xl text-[#505A5A]/70 leading-relaxed">
            Let our Surrey specialists handle licensing, compliance, and management so you can focus on maximizing returns in BC's fastest-growing rental market.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {contactMethods.map((method, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#882629] rounded-xl mx-auto mb-6">
                <i className={`${method.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-[#505A5A] mb-2">
                {method.title}
              </h3>
              <div className="text-[#882629] font-semibold text-lg mb-3">
                {method.detail}
              </div>
              <p className="text-sm text-[#505A5A]/70">
                {method.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-10 shadow-lg max-w-4xl mx-auto">
          <h3 className="text-2xl font-semibold text-[#505A5A] mb-8 text-center">
            What We Handle for Surrey Homeowners
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-1"></i>
              <div>
                <strong className="text-[#505A5A]">Complete Licensing Process</strong>
                <p className="text-sm text-[#505A5A]/70 mt-1">Business license application, documentation, and approval management</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-1"></i>
              <div>
                <strong className="text-[#505A5A]">Zoning & Compliance Review</strong>
                <p className="text-sm text-[#505A5A]/70 mt-1">Property assessment and regulatory compliance verification</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-1"></i>
              <div>
                <strong className="text-[#505A5A]">Safety Certifications</strong>
                <p className="text-sm text-[#505A5A]/70 mt-1">Fire safety equipment, inspections, and documentation</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-1"></i>
              <div>
                <strong className="text-[#505A5A]">Tax Setup & Collection</strong>
                <p className="text-sm text-[#505A5A]/70 mt-1">MRDT, PST, and GST/HST registration and remittance</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-1"></i>
              <div>
                <strong className="text-[#505A5A]">Platform Optimization</strong>
                <p className="text-sm text-[#505A5A]/70 mt-1">Professional listings on Airbnb, VRBO with license display</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-1"></i>
              <div>
                <strong className="text-[#505A5A]">Ongoing Management</strong>
                <p className="text-sm text-[#505A5A]/70 mt-1">Guest communication, cleaning, maintenance, and compliance monitoring</p>
              </div>
            </div>
          </div>

          <div className="mt-10 text-center">
            <button 
              onClick={handleAssessment}
              className="bg-[#882629] text-white px-12 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
            >
              Get Your Free Surrey STR Assessment
            </button>
            <p className="text-sm text-[#505A5A]/70 mt-4">
              No obligation consultation • Surrey market analysis included
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#505A5A]/70 italic max-w-2xl mx-auto">
            <strong className="text-[#505A5A] not-italic">Surrey Specialist Team:</strong> Our local experts understand Surrey's unique market dynamics, emerging regulations, and neighborhood-specific opportunities to maximize your rental success.
          </p>
        </div>
      </div>
    </section>
  );
}
